// Bilingual translations for PROGÈRE Devis AI
export const translations = {
  fr: {
    brand: { devis: "Devis AI", slogan: "Des soumissions intelligentes, rapides et professionnelles." },
    nav: { features: "Fonctionnalités", pricing: "Tarifs", demo: "Démonstration", login: "Connexion", signup: "S'inscrire" },
    hero: {
      badge: "IA · Construction · Québec",
      title_a: "PRO", title_b: "GÈRE", title_c: "Devis AI",
      subtitle: "Créez des soumissions professionnelles en quelques minutes grâce à l'intelligence artificielle.",
      cta1: "Créer une soumission",
      cta2: "Demander une démonstration",
    },
    features: {
      title: "Construit pour les entrepreneurs du Québec",
      sub: "Une plateforme complète pour estimer, soumettre et conclure plus rapidement.",
      list: [
        { t: "Génération par IA", d: "Décrivez un projet — l'IA crée la soumission complète avec items, scope, exclusions et conditions." },
        { t: "Calculs TPS/TVQ", d: "Taxes du Québec calculées automatiquement. Marges, profits et heures suggérées." },
        { t: "Soumissions PDF Premium", d: "Documents professionnels noir, or et rouge prêts à être envoyés aux clients." },
        { t: "Templates de métiers", d: "Nettoyage, gypse, joints, peinture, planchers, extras, T&M, gestion générale." },
        { t: "Assistant IA Chat", d: "Réécrit professionnellement, ajoute exclusions, calcule heures et marge." },
        { t: "Suivi des soumissions", d: "Brouillon, Envoyée, Vue, Approuvée, Rejetée, Expirée, Convertie." },
      ],
    },
    pricing: {
      title: "Une tarification claire",
      sub: "Choisissez le plan qui correspond à votre équipe.",
      plans: [
        { name: "Starter", plan_id: "starter", price: "49 $", period: "/ mois", desc: "Pour les entrepreneurs autonomes.", cta: "Commencer",
          features: ["20 soumissions / mois", "Génération IA de base", "Export PDF", "1 utilisateur"] },
        { name: "Pro", plan_id: "pro", price: "149 $", period: "/ mois", featured: true, desc: "Pour les équipes en croissance.", cta: "Essayer Pro",
          features: ["Soumissions illimitées", "IA avancée Claude Sonnet 4.5", "Templates personnalisés", "5 utilisateurs", "Suivi avancé"] },
        { name: "Entreprise", plan_id: "enterprise", price: "Sur mesure", period: "", desc: "Pour les grandes équipes.", cta: "Nous contacter",
          features: ["Tout dans Pro", "Utilisateurs illimités", "Intégrations sur mesure", "Support prioritaire", "Onboarding dédié"] },
      ],
      erp_badge: "Abonnement spécial · Sur demande",
      erp_title: "PROGÈRE ERP · Gestion de chantier complète",
      erp_sub: "Connectez Devis AI à la suite PROGÈRE ERP pour gérer chantiers, ressources, échéanciers, facturation et conformité CCQ — tout en un.",
      erp_features: [
        "Synchronisation soumissions ↔ chantiers en temps réel",
        "Gestion des feuilles de temps CCQ et bons de travail",
        "Bons de commande, livraisons et inventaire",
        "Facturation progressive et retenues légales",
        "Tableaux de bord financiers multi-projets",
        "Module mobile chantier (iOS / Android)",
        "Intégrations comptables (Acomba, Sage, QuickBooks)",
        "Conformité CCQ, CNESST, RBQ",
      ],
      erp_cta: "Demander une démonstration ERP",
      erp_price: "Sur demande",
      erp_price_sub: "Tarif personnalisé selon la taille de l'équipe",
    },
    erp_form: {
      title: "Demander une démonstration ERP",
      sub: "Remplissez ce formulaire et notre équipe vous contactera dans les 24 heures.",
      name: "Nom complet",
      company: "Entreprise",
      email: "Courriel",
      phone: "Téléphone",
      team_size: "Taille de l'équipe",
      team_options: ["1-5 employés", "6-20 employés", "21-50 employés", "50+ employés"],
      city: "Ville",
      rbq: "Numéro RBQ (facultatif)",
      work_type: "Type de travaux principal",
      message: "Message / Besoins spécifiques",
      submit: "Envoyer la demande",
      sending: "Envoi en cours...",
      success_title: "Demande envoyée !",
      success_msg: "Merci. Notre équipe vous contactera très bientôt pour planifier votre démonstration personnalisée.",
      back: "Retour à l'accueil",
      another: "Soumettre une autre demande",
    },
    erp_admin: {
      title: "Demandes ERP",
      sub: "Pistes commerciales pour PROGÈRE ERP / Gestion de chantier",
      empty: "Aucune demande pour le moment.",
      mark_read: "Marquer lue",
      mark_unread: "Marquer non lue",
      delete: "Supprimer",
      new: "Nouvelle",
      contacted: "Contactée",
      qualified: "Qualifiée",
      closed_won: "Convertie",
      closed_lost: "Fermée",
      notes_placeholder: "Notes internes...",
      save_notes: "Enregistrer les notes",
    },
    auth: {
      login_title: "Connexion à PROGÈRE Devis AI",
      register_title: "Créer un compte",
      email: "Courriel",
      password: "Mot de passe",
      name: "Nom complet",
      company: "Entreprise",
      login: "Se connecter",
      register: "S'inscrire",
      to_register: "Pas de compte ? S'inscrire",
      to_login: "Déjà inscrit ? Connexion",
      back_home: "Retour à l'accueil",
    },
    sidebar: {
      dashboard: "Tableau de bord",
      quotes: "Soumissions",
      new_quote: "Nouvelle soumission",
      clients: "Clients",
      projects: "Projets",
      templates: "Templates",
      assistant: "Assistant IA",
      erp_leads: "Demandes ERP",
      settings: "Paramètres",
      logout: "Déconnexion",
    },
    dashboard: {
      title: "Tableau de bord",
      welcome: "Bienvenue",
      seed: "Charger les données démo",
      kpi: {
        total: "Soumissions totales",
        pending: "En attente",
        revenue: "Revenu soumissionné",
        conversion: "Taux de conversion",
        approved: "Approuvées",
        avg: "Valeur moyenne",
      },
      monthly: "Ventes mensuelles",
      recent: "Soumissions récentes",
      ai_tips: "Suggestions IA",
      tips: [
        "Ajoutez une marge de 18% sur les projets de moins de 5 000 $.",
        "Relancez les soumissions vues mais non approuvées après 3 jours.",
        "Activez l'expiration auto à 30 jours pour préserver vos marges.",
      ],
    },
    quotes: {
      title: "Soumissions",
      new: "Nouvelle soumission",
      number: "Numéro", client: "Client", project: "Projet", total: "Total", status: "Statut", date: "Date", actions: "Actions",
      empty: "Aucune soumission. Créez-en une nouvelle.",
      builder: {
        title: "Création de soumission",
        ai_prompt: "Décrivez le projet (l'IA va générer la soumission)",
        ai_placeholder: "Ex. Créer une soumission pour un nettoyage après construction de 32 000 pi² incluant vitres, planchers, salles de bain, dépoussiérage complet et gestion des déchets.",
        generate: "Générer avec l'IA",
        generate_photos: "Générer à partir des fichiers",
        upload_photos: "Téléverser photos ou plans du chantier",
        photos_hint: "Photos: JPEG, PNG, WEBP (max 6, 10 Mo) · Plans: PDF (max 3, 20 Mo) · Prenez aussi des photos en direct sur mobile",
        take_photo: "Prendre une photo",
        add_photos: "Ajouter des photos",
        add_plans: "Ajouter des plans PDF",
        analyzing_photos: "L'IA analyse vos photos et plans...",
        manual: "Saisir manuellement",
        client_info: "Information client",
        project_info: "Information projet",
        items: "Items de ligne",
        item_desc: "Description", qty: "Qté", unit: "Unité",
        mat: "Matériel", lab: "Main-d'œuvre", eq: "Équipement", sub: "Sous-trait.", profit: "Profit %", total_col: "Total",
        add_item: "+ Ajouter un item",
        scope: "Scope of work",
        exclusions: "Exclusions",
        conditions: "Conditions",
        payment: "Modalités de paiement",
        save: "Enregistrer la soumission",
        saving: "Enregistrement...",
        generating: "L'IA travaille...",
      },
    },
    detail: {
      pdf: "Télécharger PDF",
      send: "Marquer envoyée",
      approve: "Approuver",
      reject: "Rejeter",
      scope: "Scope of work",
      excl: "Exclusions",
      cond: "Conditions",
      payment: "Modalités",
      subtotal: "Sous-total",
      gst: "TPS (5%)",
      qst: "TVQ (9,975%)",
      total: "Total",
      sig: "Signature du client",
    },
    clients_p: { title: "Clients", new: "Nouveau client", name: "Nom", company: "Entreprise", email: "Courriel", phone: "Téléphone", address: "Adresse", save: "Enregistrer", empty: "Aucun client." },
    projects_p: { title: "Projets", new: "Nouveau projet", name: "Nom du projet", address: "Adresse", save: "Enregistrer", empty: "Aucun projet." },
    templates_p: { title: "Templates de soumissions", use: "Utiliser ce template",
      edit: "Modifier",
      reset: "Réinitialiser",
      delete: "Supprimer",
      duplicate: "Dupliquer",
      new: "Nouveau template",
      custom: "Personnalisé",
      base_rate: "Tarif de base",
      save: "Enregistrer",
      cancel: "Annuler",
      add_item: "Ajouter un item",
      tpl_name: "Nom du template",
      tpl_category: "Catégorie",
      tpl_notes: "Note",
      confirm_reset: "Réinitialiser ce template aux valeurs par défaut ?",
      confirm_delete: "Supprimer ce template personnalisé ?",
    },
    assistant_p: { title: "Assistant IA PROGÈRE", placeholder: "Posez une question, demandez de rédiger une soumission, etc.", send: "Envoyer", clear: "Nouvelle conversation", thinking: "L'IA réfléchit..." },
    settings_p: { title: "Paramètres", company: "Entreprise", gst: "Numéro TPS", qst: "Numéro TVQ", terms: "Conditions par défaut", profit: "Marge de profit par défaut (%)", rate: "Taux horaire ($)", markup: "Majoration matériel (%)", save: "Enregistrer",
      ccq_title: "Ajustement automatique CCQ",
      ccq_desc: "Appliquer la hausse +5% des taux CCQ à compter du 26 avril 2026 sur la main-d'œuvre des templates et des soumissions générées par l'IA.",
      ccq_active: "Hausse +5% actuellement appliquée",
      ccq_pending: "Hausse activée — sera appliquée le 26 avril 2026",
      ccq_off: "Ajustement désactivé",
      inflation_title: "Inflation matériel 2026",
      inflation_desc: "Ajuster automatiquement le coût matériel selon l'inflation construction québécoise (par défaut +2,5%). Appliqué aux templates et aux soumissions IA.",
      inflation_pct: "Pourcentage d'inflation (%)",
      inflation_active: "Inflation matériel actuellement appliquée",
      inflation_off: "Inflation matériel désactivée",
    },
    status: {
      draft: "Brouillon", sent: "Envoyée", viewed: "Vue", approved: "Approuvée",
      rejected: "Rejetée", expired: "Expirée", converted: "Convertie",
    },
  },
  en: {
    brand: { devis: "Devis AI", slogan: "Smart, fast and professional construction quotes." },
    nav: { features: "Features", pricing: "Pricing", demo: "Demo", login: "Log in", signup: "Sign up" },
    hero: {
      badge: "AI · Construction · Quebec",
      title_a: "PRO", title_b: "GÈRE", title_c: "Devis AI",
      subtitle: "Create professional construction quotes in minutes with the power of AI.",
      cta1: "Create a quote",
      cta2: "Request a demo",
    },
    features: {
      title: "Built for Quebec contractors",
      sub: "A complete platform to estimate, quote and close faster.",
      list: [
        { t: "AI generation", d: "Describe a project — AI builds the full quote with items, scope, exclusions and conditions." },
        { t: "GST/QST calculations", d: "Quebec taxes computed automatically. Margins, profits and hours suggested." },
        { t: "Premium PDF quotes", d: "Black, gold and red professional documents ready to send to clients." },
        { t: "Trade templates", d: "Cleaning, drywall, joints, paint, flooring, extras, T&M, GC management." },
        { t: "AI chat assistant", d: "Rewrites professionally, adds exclusions, computes hours and margins." },
        { t: "Quote tracking", d: "Draft, Sent, Viewed, Approved, Rejected, Expired, Converted." },
      ],
    },
    pricing: {
      title: "Clear pricing",
      sub: "Pick the plan that fits your team.",
      plans: [
        { name: "Starter", plan_id: "starter", price: "$49", period: "/ mo", desc: "For solo contractors.", cta: "Get started",
          features: ["20 quotes / month", "Basic AI generation", "PDF export", "1 user"] },
        { name: "Pro", plan_id: "pro", price: "$149", period: "/ mo", featured: true, desc: "For growing teams.", cta: "Try Pro",
          features: ["Unlimited quotes", "Advanced AI Claude Sonnet 4.5", "Custom templates", "5 users", "Advanced tracking"] },
        { name: "Enterprise", plan_id: "enterprise", price: "Custom", period: "", desc: "For large teams.", cta: "Contact us",
          features: ["Everything in Pro", "Unlimited users", "Custom integrations", "Priority support", "Dedicated onboarding"] },
      ],
      erp_badge: "Special subscription · On request",
      erp_title: "PROGÈRE ERP · Full construction management",
      erp_sub: "Connect Devis AI to the PROGÈRE ERP suite to manage job sites, resources, schedules, billing and CCQ compliance — all in one.",
      erp_features: [
        "Real-time quote ↔ job site sync",
        "CCQ timesheets and work orders",
        "Purchase orders, deliveries and inventory",
        "Progress billing and legal holdbacks",
        "Multi-project financial dashboards",
        "Mobile site module (iOS / Android)",
        "Accounting integrations (Acomba, Sage, QuickBooks)",
        "CCQ, CNESST, RBQ compliance",
      ],
      erp_cta: "Request ERP demo",
      erp_price: "On request",
      erp_price_sub: "Custom pricing based on team size",
    },
    erp_form: {
      title: "Request an ERP demo",
      sub: "Fill out this form and our team will contact you within 24 hours.",
      name: "Full name",
      company: "Company",
      email: "Email",
      phone: "Phone",
      team_size: "Team size",
      team_options: ["1-5 employees", "6-20 employees", "21-50 employees", "50+ employees"],
      city: "City",
      rbq: "RBQ number (optional)",
      work_type: "Main work type",
      message: "Message / Specific needs",
      submit: "Send request",
      sending: "Sending...",
      success_title: "Request sent!",
      success_msg: "Thank you. Our team will contact you very soon to schedule your personalized demo.",
      back: "Back to home",
      another: "Submit another request",
    },
    erp_admin: {
      title: "ERP requests",
      sub: "Sales leads for PROGÈRE ERP / Construction management",
      empty: "No requests yet.",
      mark_read: "Mark as read",
      mark_unread: "Mark as unread",
      delete: "Delete",
      new: "New",
      contacted: "Contacted",
      qualified: "Qualified",
      closed_won: "Closed won",
      closed_lost: "Closed lost",
      notes_placeholder: "Internal notes...",
      save_notes: "Save notes",
    },
    auth: {
      login_title: "Sign in to PROGÈRE Devis AI",
      register_title: "Create an account",
      email: "Email", password: "Password", name: "Full name", company: "Company",
      login: "Log in", register: "Sign up",
      to_register: "No account? Sign up", to_login: "Already registered? Log in",
      back_home: "Back to home",
    },
    sidebar: {
      dashboard: "Dashboard", quotes: "Quotes", new_quote: "New quote",
      clients: "Clients", projects: "Projects", templates: "Templates",
      assistant: "AI Assistant", erp_leads: "ERP requests", settings: "Settings", logout: "Sign out",
    },
    dashboard: {
      title: "Dashboard", welcome: "Welcome", seed: "Load demo data",
      kpi: { total: "Total quotes", pending: "Pending", revenue: "Quoted revenue", conversion: "Conversion rate", approved: "Approved", avg: "Average value" },
      monthly: "Monthly sales", recent: "Recent quotes", ai_tips: "AI suggestions",
      tips: [
        "Add an 18% margin on projects under $5,000.",
        "Follow up on viewed but unapproved quotes after 3 days.",
        "Enable 30-day auto-expiry to protect your margins.",
      ],
    },
    quotes: {
      title: "Quotes", new: "New quote",
      number: "Number", client: "Client", project: "Project", total: "Total", status: "Status", date: "Date", actions: "Actions",
      empty: "No quotes yet. Create one.",
      builder: {
        title: "Quote builder",
        ai_prompt: "Describe the project (AI will generate the quote)",
        ai_placeholder: "Ex. Create a quote for a 32,000 sqft post-construction cleaning including windows, floors, bathrooms, full dusting and waste management.",
        generate: "Generate with AI",
        generate_photos: "Generate from files",
        upload_photos: "Upload photos or site plans",
        photos_hint: "Photos: JPEG, PNG, WEBP (max 6, 10 MB) · Plans: PDF (max 3, 20 MB) · Or capture live photos on mobile",
        take_photo: "Take a photo",
        add_photos: "Add photos",
        add_plans: "Add PDF plans",
        analyzing_photos: "AI is analyzing your photos and plans...",
        manual: "Enter manually",
        client_info: "Client info", project_info: "Project info",
        items: "Line items",
        item_desc: "Description", qty: "Qty", unit: "Unit",
        mat: "Material", lab: "Labor", eq: "Equipment", sub: "Subcontr.", profit: "Profit %", total_col: "Total",
        add_item: "+ Add item",
        scope: "Scope of work", exclusions: "Exclusions", conditions: "Conditions",
        payment: "Payment terms",
        save: "Save quote", saving: "Saving...", generating: "AI is working...",
      },
    },
    detail: { pdf: "Download PDF", send: "Mark sent", approve: "Approve", reject: "Reject", scope: "Scope of work", excl: "Exclusions", cond: "Conditions", payment: "Terms", subtotal: "Subtotal", gst: "GST (5%)", qst: "QST (9.975%)", total: "Total", sig: "Client signature" },
    clients_p: { title: "Clients", new: "New client", name: "Name", company: "Company", email: "Email", phone: "Phone", address: "Address", save: "Save", empty: "No clients." },
    projects_p: { title: "Projects", new: "New project", name: "Project name", address: "Address", save: "Save", empty: "No projects." },
    templates_p: { title: "Quote templates", use: "Use this template",
      edit: "Edit", reset: "Reset", delete: "Delete", duplicate: "Duplicate", new: "New template",
      custom: "Customized", base_rate: "Base rate", save: "Save", cancel: "Cancel",
      add_item: "Add item", tpl_name: "Template name", tpl_category: "Category", tpl_notes: "Note",
      confirm_reset: "Reset this template to default values?",
      confirm_delete: "Delete this custom template?",
    },
    assistant_p: { title: "PROGÈRE AI Assistant", placeholder: "Ask a question, ask to draft a quote, etc.", send: "Send", clear: "New chat", thinking: "AI is thinking..." },
    settings_p: { title: "Settings", company: "Company", gst: "GST number", qst: "QST number", terms: "Default terms", profit: "Default profit margin (%)", rate: "Hourly rate ($)", markup: "Material markup (%)", save: "Save",
      ccq_title: "CCQ auto-adjustment",
      ccq_desc: "Apply the +5% CCQ wage increase from April 26, 2026 to template labor rates and AI-generated quotes.",
      ccq_active: "+5% increase currently applied",
      ccq_pending: "Adjustment enabled — will apply on April 26, 2026",
      ccq_off: "Adjustment disabled",
      inflation_title: "Material inflation 2026",
      inflation_desc: "Auto-adjust material cost to Quebec construction inflation (default +2.5%). Applied to templates and AI quotes.",
      inflation_pct: "Inflation percentage (%)",
      inflation_active: "Material inflation currently applied",
      inflation_off: "Material inflation disabled",
    },
    status: { draft: "Draft", sent: "Sent", viewed: "Viewed", approved: "Approved", rejected: "Rejected", expired: "Expired", converted: "Converted" },
  },
};
